import React from 'react';
import { Button, Checkbox, Form, Grid, Header, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import {
    fetchAcademicYears, fetchStudentStatuses,
    fetchStudyCycle,
    fetchStudyType, fetchStudyYears,
} from '../../Lookups/util';

import ReactExport from 'react-data-export';
import ReportExcelFile from './ReportExcelFile';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from '../../util/PaginationFront';
import request from '../../util/request';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';
import {
    additionalFilterSectionStyle,
    checkboxFieldStyle,
    filterFieldGridStyle,
    renderStudentIndicators,
    requiredFilterSectionStyle
} from './reportUiHelpers';

const ExcelFile = ReportExcelFile;
const { ExcelSheet } = ReactExport.ExcelFile;

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

class StudentsWithNotPassedCourses extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstTimeEnrolled: false,
            moreThanOnceEnrolled: false,
            studyCycleId: null,
            studyTypeId: null,
            studyYearId: null,
            studentStatusId: null,
            socialStatusId: null,
            studyProgramSemesterId: null,
            studyProgramBasicId: null,
            academicYearId: null,
            studyCycles: [],
            studyTypes: [],
            studentStatuses: [],
            studyProgramBasics: [],
            studyProgramBasicsAll: [],
            studyYears: [],
            studyProgramSemesters: [],
            studyProgramSemestersAll: [],
            socialStatusTypes: [],
            semesters: [],
            academicYears: [],
            students: [],
            loaded: null,
            results: [],
            activePage: 1,
            postsPerPage: 20,
            excelData: [],
            exactNumberOfEnrollments: null,
            excludeDroppedOut: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.filter = this.filter.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    componentDidMount() {
        axios.post('study-programs/basic', {})
            .then(res => {
                const studyProgramBasics = res.data.map(el => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name,
                    description: el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                this.setState({ studyProgramBasics, studyProgramBasicsAll: studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });

        axios.get('/study-program-semesters')
            .then(res => {
                const studyProgramSemesters = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({ studyProgramSemesters, studyProgramSemestersAll: studyProgramSemesters });
            });

        axios.all([fetchAcademicYears(), fetchStudyCycle(), fetchStudyType(), fetchStudentStatuses(), fetchStudyYears(), request.fetchSocialStatuses()])
            .then(axios.spread((yearsRes, studyCycleRes, studyTypesRes, studentStatusesRes, studyYearsRes, socialStatusRes) => {
                const academicYears = yearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                })).reverse();

                const studyCycles = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                const studyTypes = studyTypesRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                let studentStatuses = studentStatusesRes.data.filter(e => e._key === 'regular' || e._key === 'exchange' || e._key === 'guest' || e._key === 'grad_again').map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                    studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                }

                const studyYears = studyYearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));

                this.setState({
                    studyCycles,
                    studyTypes,
                    studentStatuses,
                    studyYears,
                    academicYears,
                    socialStatusTypes: socialStatusRes
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch report filters');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({ [name]: value === '' ? null : value });

        if (name === 'academicYearId') {
            this.setState({ semester: null });
            axios.get(`semester/by-academic-year/${value}`)
                .then(res => {
                    this.setState({
                        semesters: res.data.filter(e => e.name.name !== 'ostalo' && e.name.name !== 'ljetna škola').map(el => ({
                            ...el, key: el.id, value: el.id, text: el.name.name
                        }))
                    });
                });
        }

        if (name === 'studyCycleId') {
            if (value === null || value === '') {
                this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll });
            } else {
                this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll.filter(el => el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].id === value : null) });
            }
        }

        if (name === 'studyYearId') {
            if (value === null || value === '') {
                this.setState({ studyProgramSemesters: this.state.studyProgramSemestersAll });
            } else {
                this.setState({ studyProgramSemesters: this.state.studyProgramSemestersAll.filter(e => e.studyYear.id === value) });
            }
        }
    }

    buildExcelData(data) {
        return data.map(el => {
            const student = el.studentStudyProgramDTO;
            const notPassedCourses = el.notPassedCourses || [];

            return [
                { value: student.lastName },
                { value: student.firstName },
                { value: student.fatherName ? student.fatherName : '' },
                { value: student.index ? student.index : '' },
                { value: student.studyCycleName },
                { value: student.studyProgramBasicName },
                { value: student.studyProgramName },
                { value: student.studyYearName },
                { value: student.studyProgramSemesterName },
                { value: student.studyTypeName },
                { value: student.studentStatusName },
                { value: notPassedCourses.length },
                { value: notPassedCourses.reduce((total, course) => total + (course.ects || 0), 0) },
                { value: notPassedCourses.map(course => `${course.courseName}${course.semester ? ` (${course.semester})` : ''}${course.ects ? ` - ${course.ects} ECTS` : ''}`).join('; ') },
            ];
        });
    }

    filter() {
        this.setState({ loaded: false, results: [], activePage: 1 });

        const obj = {
            firstTimeEnrolled: this.state.firstTimeEnrolled,
            moreThanOnceEnrolled: this.state.moreThanOnceEnrolled,
            studyCycleId: this.state.studyCycleId,
            studyTypeId: this.state.studyTypeId,
            studyYearId: this.state.studyYearId,
            socialStatusId: this.state.socialStatusId,
            studentStatusId: this.state.studentStatusId,
            studyProgramSemesterId: this.state.studyProgramSemesterId,
            studyProgramBasicId: this.state.studyProgramBasicId,
            exactNumberOfEnrollments: this.state.exactNumberOfEnrollments === '' ? null : this.state.exactNumberOfEnrollments,
            excludeDroppedOut: this.state.excludeDroppedOut
        };

        axios.post(`reports/students-with-not-passed-courses/${this.state.semester}/`, { ...obj })
            .then(res => {
                const students = res.data.map(el => {
                    const student = el.studentStudyProgramDTO;
                    const notPassedCourses = el.notPassedCourses || [];

                    return {
                        ...el,
                        lastNameF: student.lastName,
                        firstNameF: student.firstName,
                        fatherNameF: student.fatherName,
                        indexF: student.index,
                        studyCycleNameF: student.studyCycleName,
                        studyProgramBasicNameF: student.studyProgramBasicName,
                        studyProgramNameF: student.studyProgramName,
                        studyProgramSemesterNameF: student.studyProgramSemesterName,
                        studyTypeNameF: student.studyTypeName,
                        studentStatusNameF: student.studentStatusName,
                        coursesF: notPassedCourses.map(course => course.courseName).join(' ')
                    };
                });

                this.setState({
                    students,
                    loaded: true,
                    excelData: this.buildExcelData(students)
                });
            });
    }

    getResults(results) {
        this.setState({
            results,
            excelData: this.buildExcelData(results.length === 0 ? this.state.students : results)
        });
        this.handlePaginationChange({}, { activePage: 1 });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.students;
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {
        const numberOfEnrollments = [
            { key: 2, text: '2', value: 2 },
            { key: 3, text: '3', value: 3 },
            { key: 4, text: '4', value: 4 },
            { key: 5, text: '5', value: 5 },
            { key: 6, text: '6', value: 6 },
            { key: 7, text: '7', value: 7 },
            { key: 8, text: '8', value: 8 },
            { key: 9, text: '9', value: 9 },
            { key: 10, text: '10', value: 10 },
        ];

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [{
            columns: [
                { title: 'Prezime', width: { wpx: 200 } },
                { title: 'Ime', width: { wpx: 150 } },
                { title: 'Ime oca', width: { wpx: 150 } },
                { title: 'Index', width: { wpx: 150 } },
                { title: 'Ciklus', width: { wpx: 150 } },
                { title: 'Studijski program', width: { wpx: 300 } },
                { title: 'NPP', width: { wpx: 250 } },
                { title: 'Godina studija', width: { wpx: 150 } },
                { title: 'Semestar studija', width: { wpx: 150 } },
                { title: 'Tip studiranja', width: { wpx: 200 } },
                { title: 'Status studenta', width: { wpx: 180 } },
                { title: 'Broj nepoloženih predmeta', width: { wpx: 180 } },
                { title: 'Ukupno ECTS', width: { wpx: 120 } },
                { title: 'Nepoloženi predmeti', width: { wpx: 1500 } },
            ],
            data: this.state.excelData,
        }];

        return (
            <div>
                <Form>
                    <Segment style={requiredFilterSectionStyle}>
                        <Header as="h4" color="blue">Obavezni parametri</Header>
                        <Form.Group widths="equal" style={filterFieldGridStyle}>
                            <Form.Field>
                                <Form.Dropdown label="Akademska godina" clearable placeholder="Odaberite akademsku godinu" value={this.state.academicYearId} onChange={this.handleInputChange} name="academicYearId" options={this.state.academicYears} search fluid selection />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown label="Semestar studija" disabled={!this.state.academicYearId} placeholder="Odaberite semestar studija" options={this.state.semesters} onChange={this.handleInputChange} name="semester" value={this.state.semester} search fluid selection />
                            </Form.Field>
                            <Form.Field />
                        </Form.Group>
                    </Segment>

                    <Segment style={additionalFilterSectionStyle}>
                        <Header as="h4" color="blue">Dodatni filteri</Header>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Form.Dropdown label="Ciklus studija" disabled={!this.state.semester} clearable placeholder="Odaberite ciklus" options={this.state.studyCycles} onChange={this.handleInputChange} name="studyCycleId" value={this.state.studyCycleId} search fluid selection />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown label="Studijski program" disabled={!this.state.semester} clearable placeholder="Odaberite studijski program" options={this.state.studyProgramBasics} onChange={this.handleInputChange} name="studyProgramBasicId" value={this.state.studyProgramBasicId} search fluid selection />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown label="Tip studiranja" disabled={!this.state.semester} clearable placeholder="Odaberite tip studiranja" value={this.state.studyTypeId} onChange={this.handleInputChange} name="studyTypeId" options={this.state.studyTypes} search fluid selection />
                            </Form.Field>
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Field>
                                <Form.Dropdown label="Status studenta" disabled={!this.state.semester} clearable placeholder="Odaberite status" value={this.state.studentStatusId} onChange={this.handleInputChange} name="studentStatusId" options={this.state.studentStatuses} search fluid selection />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown label="Godina studija" disabled={!this.state.semester} clearable placeholder="Odaberite godinu studija" options={this.state.studyYears} onChange={this.handleInputChange} name="studyYearId" value={this.state.studyYearId} search fluid selection />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown label="Semestar studija" disabled={!this.state.semester} clearable placeholder="Odaberite semestar studija" options={this.state.studyProgramSemesters} onChange={this.handleInputChange} name="studyProgramSemesterId" value={this.state.studyProgramSemesterId} search fluid selection />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Form.Dropdown label="Socijalni status" disabled={!this.state.semester} clearable placeholder="Odaberite socijalni status" options={this.state.socialStatusTypes} onChange={this.handleInputChange} name="socialStatusId" value={this.state.socialStatusId} search fluid selection />
                            </Form.Field>
                            <Form.Field />
                            <Form.Field />
                        </Form.Group>

                        <Form.Group inline>
                            <Form.Field style={checkboxFieldStyle}>
                                <Checkbox disabled={!this.state.semester} checked={this.state.firstTimeEnrolled} label="Samo prvi put upisani" value={this.state.firstTimeEnrolled} onChange={() => this.setState({ firstTimeEnrolled: !this.state.firstTimeEnrolled, moreThanOnceEnrolled: false, exactNumberOfEnrollments: null })} />
                            </Form.Field>
                            <Form.Field style={checkboxFieldStyle}>
                                <Checkbox disabled={!this.state.semester} checked={this.state.moreThanOnceEnrolled} label="Samo ponovci" value={this.state.moreThanOnceEnrolled} onChange={() => this.setState({ moreThanOnceEnrolled: !this.state.moreThanOnceEnrolled, firstTimeEnrolled: false })} />
                            </Form.Field>
                            <Form.Field style={checkboxFieldStyle}>
                                <Checkbox disabled={!this.state.semester} checked={this.state.excludeDroppedOut} label="Isključi ispisane" value={this.state.excludeDroppedOut} onChange={() => this.setState({ excludeDroppedOut: !this.state.excludeDroppedOut })} />
                            </Form.Field>
                        </Form.Group>
                        {this.state.moreThanOnceEnrolled &&
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <Form.Dropdown clearable label="Broj upisa" placeholder="Broj upisa" options={numberOfEnrollments} onChange={this.handleInputChange} name="exactNumberOfEnrollments" value={this.state.exactNumberOfEnrollments} search selection fluid />
                                </Form.Field>
                                <Form.Field />
                                <Form.Field />
                            </Form.Group>}
                    </Segment>

                    <Button disabled={!this.state.semester} basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button disabled={!this.state.semester} color="blue" floated="right" onClick={this.filter}>Prikaži izvještaj</Button>
                </Form>
                <br /><br /><br />
                {this.state.loaded === false ? <div><Loader active inline="centered"> Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :
                    this.state.loaded &&
                    <div>
                        {this.state.students.length ? <Table celled selectable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={22}>
                                        <Grid column={2} stackable>
                                            <Grid.Column width={14}>
                                                <SearchTableData profMozilla data={this.state.students} getResults={this.getResults} filterItem={['lastNameF', 'firstNameF', 'fatherNameF', 'indexF', 'studyProgramSemesterNameF', 'studyCycleNameF', 'studyProgramBasicNameF', 'studyProgramNameF', 'studyTypeNameF', 'studentStatusNameF', 'coursesF']} />
                                            </Grid.Column>
                                            <Grid.Column width={2} textAlign="center">
                                                <ExcelFile filename="Studenti sa nepolozenim predmetima" element={<Popup trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}><Button.Content hidden> <Icon name="download" /></Button.Content><Button.Content visible>Excel</Button.Content></Button>} content="Preuzmi spisak u Excel-u" hideOnScroll position="top center" />}>
                                                    <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Studenti" />
                                                </ExcelFile>
                                            </Grid.Column>
                                        </Grid>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell width="1">R.br.</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={3}>Prezime (ime oca) ime</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}>Index</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}>Ciklus</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={4}>Studijski program - NPP</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}>Semestar studija</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}>Tip / status</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}>Broj / ECTS</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={4}>Nepoloženi predmeti</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>{currentPosts.map((el, index) => {
                                const student = el.studentStudyProgramDTO;
                                const notPassedCourses = el.notPassedCourses || [];
                                const ectsTotal = notPassedCourses.reduce((total, course) => total + (course.ects || 0), 0);

                                return (
                                    <Table.Row key={student.id}>
                                        <Table.Cell verticalAlign="middle" width="1">{(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.</Table.Cell>
                                        <Table.Cell colSpan={3} verticalAlign="middle">
                                            {student.lastName} ({student.fatherName}) {student.firstName}
                                            {renderStudentIndicators(student)}
                                        </Table.Cell>
                                        <Table.Cell colSpan={2} verticalAlign="middle">{student.index}</Table.Cell>
                                        <Table.Cell colSpan={2} verticalAlign="middle">{student.studyCycleName}</Table.Cell>
                                        <Table.Cell colSpan={4} verticalAlign="middle">{student.studyProgramBasicName} - {student.studyProgramName}</Table.Cell>
                                        <Table.Cell colSpan={2} verticalAlign="middle">{student.studyYearName} / {student.studyProgramSemesterName}</Table.Cell>
                                        <Table.Cell colSpan={2} verticalAlign="middle">{student.studyTypeName}<br /><span style={{ color: '#a6a4a1' }}>{student.studentStatusName}</span></Table.Cell>
                                        <Table.Cell colSpan={2} verticalAlign="middle">{notPassedCourses.length}<br /><span style={{ color: '#a6a4a1' }}>{ectsTotal} ECTS</span></Table.Cell>
                                        <Table.Cell colSpan={4} verticalAlign="middle">
                                            {notPassedCourses.map((course, courseIndex) => (
                                                <div key={course.courseBasicId || courseIndex}>
                                                    {courseIndex + 1}. {course.courseName}
                                                    <span style={{ color: '#a6a4a1' }}>{course.semester ? ` - ${course.semester}` : ''}{course.ects ? ` (${course.ects} ECTS)` : ''}{course.courseBasicComment ? ` - ${course.courseBasicComment}` : ''}</span>
                                                    <br />
                                                </div>
                                            ))}
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })}</Table.Body>
                        </Table> : 'Nema podataka.'}
                        {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </div>}
            </div>
        );
    }
}

export default StudentsWithNotPassedCourses;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/StudentsWithNotPassedCourses.js